// Modal reutilizable (port de modal.js) declarativo. Overlay con animación,
// cierre por ESC y clic exterior. Markup/clases 1:1.
import { useEffect, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

export type ChipColor = 'primary' | 'success' | 'warning' | 'danger' | 'info';

interface ModalProps {
  open: boolean;
  title: string;
  icon?: string;
  iconColor?: ChipColor;
  size?: 'md' | 'lg';
  footer?: ReactNode;
  footerClass?: 'split';
  onClose: () => void;
  children: ReactNode;
}

export function Modal({ open, title, icon, iconColor = 'primary', size = 'md', footer, footerClass, onClose, children }: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  return createPortal(
    <div className={`modal-overlay${open ? ' open' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className={`modal${size === 'lg' ? ' lg' : ''}`}>
        <div className="modal-header">
          {icon ? <span className={`chip c-${iconColor}`}><i className={`fa-solid ${icon}`} /></span> : null}
          <h3>{title}</h3>
          <button className="btn ghost icon-only close" onClick={onClose} aria-label="Cerrar"><i className="fa-solid fa-xmark" /></button>
        </div>
        <div className="modal-body">{children}</div>
        {footer ? <div className={`modal-footer${footerClass ? ' ' + footerClass : ''}`}>{footer}</div> : null}
      </div>
    </div>,
    document.body,
  );
}
